import { IconType } from 'react-icons';

export interface DistributionValues<I> {
  total: number;
  values: { label: I; total: number; color: string; name: string; Icon?: IconType }[];
}

export enum Orientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export enum ChartLabelPrefix {
  Indicator = 'indicator_label_',
  BloodPressure = 'severity_',
}
